import {ActionContext, Module} from 'vuex'
import {AppState} from '@/stores'
import {GetOperation} from '@/service/operation/GetOperation'
import Result from '@/service/operation/Result'
import {SiteManagerDashboardApi} from '@/service/api/sitemanager/SiteManagerDashboardApi'
import {SiteManagerDashboardBean} from '@/service/model/sitemanager/SiteManagerDashboardBean'

export interface SiteManagerDashboardModuleState {
  dashboardOperation: GetOperation<SiteManagerDashboardBean, null> | undefined
  dashboardResult: Result<SiteManagerDashboardBean> | undefined
}

export class SiteManagerDashboardModule implements Module<SiteManagerDashboardModuleState, AppState> {
  namespaced = true
  actions = {
    fetchDashboard: this.fetchDashboardAction.bind(this),
    refreshDashboard: this.refreshDashboardAction.bind(this),
  }
  mutations = {
    setDashboardOperation: (state, operation) => state.dashboardOperation = operation,
    setDashboardResult: (state, result) => state.dashboardResult = result,
  }
  getters = {
    dashboardResult: (state) => state.dashboardResult,
  }

  constructor(private readonly dashboardApi: SiteManagerDashboardApi) {}

  private async fetchDashboardAction(
    context: ActionContext<SiteManagerDashboardModuleState, AppState>
  ): Promise<SiteManagerDashboardBean | null> {
    const operation = new GetOperation<SiteManagerDashboardBean, null>(
      () => this.dashboardApi.fetchDashboard()
    )
    context.commit('setDashboardOperation', operation)
    return await operation.get(
      {params: null},
      it => context.commit('setDashboardResult', it)
    )
  }

  private async refreshDashboardAction(
    context: ActionContext<SiteManagerDashboardModuleState, AppState>
  ): Promise<SiteManagerDashboardBean | null> {
    const operation = context.state.dashboardOperation
    if (!operation) {
      return this.fetchDashboardAction(context)
    }
    return operation.refresh(true)
  }
}
